import React from "react";
import {
  ClickAwayListener,
  Fade,
  Grid,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  Paper,
  Popper,
  Tooltip,
} from "@material-ui/core"
import { MasterButton } from "App/Component/ui"
import { isNull } from "App/utils/helpers";
import { useState } from "react";
import { ModalSimpan } from "."
import { useSelector } from "react-redux"
import { MenuOpen } from "@material-ui/icons"
import { STATUS_TRANSAKI_PENJUALAN_OPEN_DRAFT } from "App/Component/layout/Penjualan/InputPenjualan/ui"
const useStyles = makeStyles({
  MuiTypography: {
    root: {
      fontSize: "12px",
    },
  },
})

const PopperTagihanPDF = ({
  isOpen,
  setIsOpen,
  clickAwayHandler,
  handleClickPrintPdf,
  handleClickPrintPdfV2,
  loadingPrint,
  loadingPrintv2,
  handleShowScale,
  anchorEl,
  row,
  defaultCetakTagihanPDF,
}) => {
  const classes = useStyles()
  return (
    <ClickAwayListener onClickAway={clickAwayHandler}>
      <Popper
        open={isOpen}
        anchorEl={anchorEl}
        placement={"bottom-start"}
        transition
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper>
              <List component="nav" aria-label="secondary mailbox folders">
                <ListItem
                  button
                  onClick={
                    loadingPrint || loadingPrintv2
                      ? () => {}
                      : parseInt(defaultCetakTagihanPDF) !== 1
                      ? () => {
                          handleClickPrintPdf()
                          setIsOpen(false)
                        }
                      : () => {
                          handleClickPrintPdfV2()
                          setIsOpen(false)
                        }
                  }
                  divider
                >
                  <ListItemText
                    secondary={
                      loadingPrint || loadingPrintv2
                        ? "Loading..."
                        : parseInt(defaultCetakTagihanPDF) !== 1
                        ? "CETAK PDF V1"
                        : "CETAK PDF V2"
                    }
                    classes={{ root: classes.root }}
                  />
                </ListItem>
                <ListItem button onClick={() => handleShowScale()}>
                  <ListItemText
                    secondary={"UBAH SKALA CETAK"}
                    classes={{ root: classes.root }}
                  />
                </ListItem>
              </List>
            </Paper>
          </Fade>
        )}
      </Popper>
    </ClickAwayListener>
  )
}

const PopperKwitansi = ({
  clickAwayHandlerKwitansi,
  isOpenKwitansi,
  handleClickPrintKwitansi,
  handleCetakKwitansiTotalBayar,
  handleCetakKwitansiSisaBayar,
  handleCetakKwitansiTotalTagihan,
  handleCetakKwitansiTotalSelisihTagihan,
  anchorElKwitansi,
  dengan_kop,
}) => {
  const classes = useStyles()
  return (
    <ClickAwayListener onClickAway={clickAwayHandlerKwitansi}>
      <Popper
        open={isOpenKwitansi}
        anchorEl={anchorElKwitansi}
        placement={"bottom-start"}
        transition
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper>
              <List component="nav" aria-label="secondary mailbox folders">
                {parseInt(dengan_kop) === 1 && (
                  <ListItem
                    button
                    onClick={() => handleClickPrintKwitansi(1)}
                    divider
                  >
                    <ListItemText
                      secondary={"CETAK LX KWITANSI KOP"}
                      classes={{ root: classes.root }}
                    />
                  </ListItem>
                )}
                <ListItem
                  button
                  onClick={() => handleCetakKwitansiTotalTagihan()}
                  divider
                >
                  <ListItemText
                    secondary={"KWITANSI TOTAL TAGIHAN"}
                    classes={{ root: classes.root }}
                  />
                </ListItem>
                <ListItem
                  button
                  onClick={() => handleCetakKwitansiTotalSelisihTagihan()}
                  divider
                >
                  <ListItemText
                    secondary={"KWITANSI SELISIH DITANGGUNG"}
                    classes={{ root: classes.root }}
                  />
                </ListItem>
                <ListItem
                  button
                  onClick={() => handleCetakKwitansiTotalBayar()}
                  divider
                >
                  <ListItemText
                    secondary={"KWITANSI TOTAL TERBAYAR"}
                    classes={{ root: classes.root }}
                  />
                </ListItem>
                <ListItem button onClick={() => handleCetakKwitansiSisaBayar()}>
                  <ListItemText
                    secondary={"KWITANSI SISA TAGIHAN"}
                    classes={{ root: classes.root }}
                  />
                </ListItem>
              </List>
            </Paper>
          </Fade>
        )}
      </Popper>
    </ClickAwayListener>
  )
}

function ButtonAction({
  setShowModalKwitansi,
  setNilaiKwitansi,
  reset,
  setNewDataTabTagihan,
  handleClickPrint,
  handleClickPrintKwitansi,
  handleClickPrintPdf,
  handleClickPrintPdfV2,
  handleClickPrintBillingObatKronis,
  loadingPrintBillingObatKronis,
  loadingPrint,
  loadingPrintv2,
  tagihanID,
  formData,
  handleShowScale,
}) {
  const [isOpen, setIsOpen] = useState(false),
    clickAwayHandler = () => setIsOpen(false),
    clickHandler = () => setIsOpen(true)
  const [isOpenKwitansi, setIsOpenKwitansi] = useState(false),
    clickAwayHandlerKwitansi = () => setIsOpenKwitansi(false),
    clickHandlerKwitansi = () => setIsOpenKwitansi(true)
  const [anchorEl, setAnchorEl] = useState(null)
  const [anchorElKwitansi, setAnchorElKwitansi] = useState(null)
  const [showModalSimpan, setShowModalSimpan] = useState(false)
  const { setting } = useSelector((state) => state)
  const cetakButtonTagihan = setting.cetak_button_tagihan
  const defaultCetakTagihanPDF = setting.default_cetak_tagihan_pdf
  const handleCetakKwitansiTotalSelisihTagihan = () => {
    const selisihTagihan = formData.ditanggung.jumlah_selisih
    setNilaiKwitansi(
      selisihTagihan < 0 ? Math.abs(selisihTagihan) : selisihTagihan,
    )
    setShowModalKwitansi(true)
    setIsOpenKwitansi(false)
  }
  const handleCetakKwitansiTotalTagihan = () => {
    setNilaiKwitansi(
      formData.is_paket
        ? formData.totalPaket?.total_paket
        : formData.pembayaran?.total_tagihan,
    )
    setShowModalKwitansi(true)
    setIsOpenKwitansi(false)
  }
  const handleCetakKwitansiTotalBayar = () => {
    setNilaiKwitansi(formData.pembayaran.total_pembayaran)
    setShowModalKwitansi(true)
    setIsOpenKwitansi(false)
  }
  const handleCetakKwitansiSisaBayar = () => {
    const sisa =
      formData.pembayaran?.total_tagihan - formData.pembayaran?.total_pembayaran
    const selisihTagihan = formData.ditanggung.jumlah_selisih

    setNilaiKwitansi(sisa + selisihTagihan)
    setShowModalKwitansi(true)
    setIsOpenKwitansi(false)
  }

  return (
    <>
      {showModalSimpan && (
        <ModalSimpan
          setNewDataTabTagihan={setNewDataTabTagihan}
          setShowModal={() => setShowModalSimpan(false)}
        />
      )}
      <div>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <div
            style={{
              display: "flex",
              gap: "10px",
            }}
          >
            <MasterButton
              type="button"
              color={"danger"}
              name={"RESET"}
              onClick={() => reset()}
              size="md"
            />

            {!isNull(tagihanID) && (
              <>
                <MasterButton
                  type="button"
                  color={"warning"}
                  name={"RINCIAN PRINTER LX"}
                  onClick={() => handleClickPrint(0)}
                  size="md"
                />

                {parseInt(cetakButtonTagihan.rincian_dengan_kop) === 1 && (
                  <MasterButton
                    type="button"
                    color={"warning"}
                    name={"RINCIAN PRINTER LX KOP"}
                    onClick={() => handleClickPrint(1)}
                    size="md"
                  />
                )}

                {formData.status_tagihan >
                  STATUS_TRANSAKI_PENJUALAN_OPEN_DRAFT && (
                  <>
                    <div
                      style={{
                        backgroundColor: "#F09F00",
                        fontWeight: "600",
                        fontSize: "10px",

                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                      }}
                    >
                      <Tooltip title={"Cetak Kwitansi Printer LX"}>
                        <div
                          style={{
                            height: "100%",
                            cursor: "pointer",
                            padding: "0.4rem 1rem",
                          }}
                          onClick={() => handleClickPrintKwitansi(0)}
                        >
                          {"KWITANSI PRINTER LX"}
                        </div>
                      </Tooltip>
                      <span
                        style={{
                          padding: "0 0.5rem",
                          color: "#fff",
                        }}
                      >
                        |
                      </span>
                      <Tooltip title="Opsi untuk pilihan cetak lainnya">
                        <div
                          id="cetak-kwitansi"
                          style={{
                            display: "flex",
                            alignContent: "center",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            cursor: "pointer",
                            padding: "0.4rem 1rem",
                          }}
                          onClick={(e) => {
                            clickHandlerKwitansi()
                            setAnchorElKwitansi(e.currentTarget)
                          }}
                        >
                          <MenuOpen
                            style={{
                              fill: "#fff",
                              marginLeft: "0.1rem",
                              fontSize: "16px",
                            }}
                          />
                        </div>
                      </Tooltip>
                    </div>
                    {isOpenKwitansi && (
                      <PopperKwitansi
                        {...{
                          clickAwayHandlerKwitansi,
                          isOpenKwitansi,
                          handleClickPrintKwitansi,
                          handleCetakKwitansiTotalBayar,
                          handleCetakKwitansiSisaBayar,
                          handleCetakKwitansiTotalTagihan,
                          handleCetakKwitansiTotalSelisihTagihan,
                          anchorElKwitansi,
                          dengan_kop: cetakButtonTagihan.kwitansi_dengan_kop,
                        }}
                      />
                    )}
                  </>
                )}

                <div
                  style={{
                    backgroundColor:
                      loadingPrintv2 || loadingPrint ? "#D8D8D8" : "#F09F00",
                    fontWeight: "600",
                    fontSize: "10px",

                    borderRadius: "6px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                  }}
                >
                  <Tooltip
                    title={
                      loadingPrintv2 || loadingPrint
                        ? "Loading.."
                        : parseInt(defaultCetakTagihanPDF) === 1
                        ? "CETAK PDF V1"
                        : "CETAK PDF V2"
                    }
                  >
                    <div
                      style={{
                        height: "100%",
                        cursor: "pointer",
                        padding: "0.4rem 1rem",
                      }}
                      onClick={
                        loadingPrintv2 || loadingPrint
                          ? () => {}
                          : parseInt(defaultCetakTagihanPDF) === 1
                          ? () => handleClickPrintPdf()
                          : () => handleClickPrintPdfV2()
                      }
                    >
                      {loadingPrintv2 || loadingPrint
                        ? "Loading.."
                        : parseInt(defaultCetakTagihanPDF) === 1
                        ? "CETAK PDF"
                        : "CETAK PDF V2"}
                    </div>
                  </Tooltip>
                  <span
                    style={{
                      padding: "0 0.5rem",
                      color: "#fff",
                    }}
                  >
                    |
                  </span>
                  <Tooltip title="Opsi untuk pilihan cetak lainnya">
                    <div
                      id="cetak-pdf"
                      style={{
                        display: "flex",
                        alignContent: "center",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        cursor: "pointer",
                        padding: "0.4rem 1rem",
                      }}
                      onClick={(e) => {
                        clickHandler()
                        setAnchorEl(e.currentTarget)
                      }}
                    >
                      <MenuOpen
                        style={{
                          fill: "#fff",
                          marginLeft: "0.1rem",
                          fontSize: "16px",
                        }}
                      />
                    </div>
                  </Tooltip>
                </div>
                {isOpen && (
                  <PopperTagihanPDF
                    {...{
                      clickAwayHandler,
                      isOpen,
                      setIsOpen,
                      handleClickPrintPdf,
                      handleClickPrintPdfV2,
                      loadingPrint,
                      loadingPrintv2,
                      handleShowScale,
                      anchorEl,
                      defaultCetakTagihanPDF,
                    }}
                  />
                )}

                <MasterButton
                  type="button"
                  color={loadingPrintBillingObatKronis ? "secondary" : "warning"}
                  name={loadingPrintBillingObatKronis ? "Loading.." : "CETAK BILLING OBAT KRONIS"}
                  onClick={
                    loadingPrintBillingObatKronis
                      ? () => {}
                      : () => handleClickPrintBillingObatKronis()
                  }
                  size="md"
                />

                {/* <MasterButton
                  type="button"
                  color={loadingPrint ? "secondary" : "warning"}
                  name={loadingPrint ? "Loading.." : "CETAK PDF"}
                  onClick={handleClickPrintPdf}
                  size="md"
                />

                <MasterButton
                  type="button"
                  color={loadingPrintv2 ? "secondary" : "warning"}
                  name={loadingPrintv2 ? "Loading.." : "CETAK PDF V2"}
                  onClick={handleClickPrintPdfV2}
                  size="md"
                /> */}
              </>
            )}
          </div>
          <div className="">
            <MasterButton
              onClick={() => setShowModalSimpan(!showModalSimpan)}
              type="submit"
              color={"green"}
              name={"SIMPAN"}
              size="md"
            />
          </div>
        </Grid>
      </div>
    </>
  )
}

export default ButtonAction
